import React, { useEffect, useRef } from 'react'

import { IMessage, ModernComment } from 'component-library-next'

import { formatDictAsHtml } from '@app/common/helpers/formatDictAsHtml'
import { CustomerDocument } from '@app/graphql/types'
import { bemJoin } from '@app/lib/bem'
import { ModernChat } from '@app/lib/components/ModernChat'
import { DocumentsList } from '@app/lib/display/DocumentsList/DocumentsList'
import { useCourtCaseContext } from '@app/modules/CourtCases/Components/CourtCaseContext/CourtCaseContext'
import { CourtCaseMessageFragment } from '@app/queries/CourtCases/CourtCase.queries'

import './styles.scss'

type CourtCaseCustomerProps = {
  message: CourtCaseMessageFragment
  isLatestQuestion: boolean
}

export const CourtCaseCustomer = ({ message, isLatestQuestion }: CourtCaseCustomerProps) => {
  const b = bemJoin('court-case-customer')
  const scrollRef = useRef<HTMLDivElement>(null)
  const { data, loading } = useCourtCaseContext()
  const { topicQuestionnaireAnswers } = message

  useEffect(() => {
    if (isLatestQuestion) {
      scrollRef.current && scrollRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [scrollRef])

  if (loading || !data) {
    return null
  }

  let enrichedMessage = message

  if (Object.keys(topicQuestionnaireAnswers).length > 0) {
    const enrichedContent = formatDictAsHtml(topicQuestionnaireAnswers)

    enrichedMessage = {
      ...message,
      content: enrichedContent
    }
  }

  return (
    <div className={b()} ref={isLatestQuestion ? scrollRef : undefined}>
      <ModernChat
        collapsesLongText={!isLatestQuestion}
        message={
          {
            ...enrichedMessage,
            documents: [],
            type: 'Question',
            customer: data.customer
          } as IMessage
        }
      >
        {message.serviceComment?.comment && (
          <ModernComment comment={message.serviceComment.comment} />
        )}
        {message.documents && <DocumentsList documents={message.documents as CustomerDocument[]} />}
      </ModernChat>
    </div>
  )
}
